import { Post, Get, Put, Delete } from "..";

export const getAllUserList = async (payload: { index: number; limit: number; }, searchValue?: string) => {
  let url = `v1/user/getAll`;
  if (searchValue) {
    url += `?search=${encodeURIComponent(searchValue)}`;
  }
  return Post({ url,payload});
};
export const createUser = async (payload:any) => {
  return Post({ url: "v1/user/create",payload});
};
export const editUser = async (id:any,payload:any) => {
  return Put({ url: `v1/user/update/${id}`,payload});
};
export const deleteUser = async (id:any) => {
  return Delete({ url: `v1/user/delete/${id}`});
};
export const deleteBulkUser = async (payload:any) => {
  return Delete({ url: `v1/user/removeBulk`,payload});
};

export const getUserByID = async (id:any) => {
    return Get({ url: `v1/user/view/${id}`});
  };

